
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as geDLz4y22tGNQtlpITG9BgMuIwInTC4Um7KomZKXwDgAMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexBTC2QbrjRnq5EiFhEI_45xSKBnz5mRDRut5byptGgggSwMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchgTPCwdBRXjZmu_45QW0CA_45P333NgycX7gWk5Kxiy0e9jEMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexeN8Lu6yqHxzRyq44JcY0t7PWS7PsuENjCuA8VNSmbfgMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93xVYXTpTd7UO3L70NvTYx3pBpN71PquzJGiBXCQboWQ8Meta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexIxMCE2xE_FFAhE6LAziSJvehniMqJTwQa8uzxVX64skMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93vl7TQ61YTeuLJ9cDJXmDmXETX0_45Q7ypwGMNOWsB9vI8Meta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexfpsgENGUY0pxSUk7FheD5vPcrY9Mfobo5OJxja_452R68Meta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93ISHPbnau2JxE5gN8_4579wqvdQIz92jFfG16noz91mHGIMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexcUcaCnSiZyEA2PNywrUn6MV1QOTGh6AB5s7Tz_vQd_oMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexsQsR93lOK38JIGK1u2_45o766Gy8XH858jRVRz4X97tOEMeta } from "/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexIxMCE2xE_FFAhE6LAziSJvehniMqJTwQa8uzxVX64skMeta || {},
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexfpsgENGUY0pxSUk7FheD5vPcrY9Mfobo5OJxja_452R68Meta || {},
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexcUcaCnSiZyEA2PNywrUn6MV1QOTGh6AB5s7Tz_vQd_oMeta || {},
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexsQsR93lOK38JIGK1u2_45o766Gy8XH858jRVRz4X97tOEMeta || {},
    component: () => import("/codebuild/output/src3355544784/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]